<!-- filepath: /var/www/ticketagrovin/frontend/src/views/AssignUserModalView.vue -->
<template>
  <div class="modal-container">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">
          Asignar técnico ticket {{ ticketId }}
        </h3>
        <button type="button" class="btn-close" @click="$emit('close')" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <!-- Eliminado el checkbox de solo mis técnicos -->

        <form @submit.prevent="handleSubmit">
          <div class="form-group">
            <label for="user-select" class="form-label">{{ $t('seleccionar_usuario') }}</label>
            <select
              id="user-select"
              v-model="selectedUser"
              class="form-control"
              required
            >
              <option v-for="user in filteredUsers" :key="user.id" :value="user.id">
                {{ user.nombre_completo }}
              </option>
            </select>
            <div v-if="!filteredUsers.length" class="help-text">{{ $t('no_hay_tecnicos') }}</div>
          </div>
          <div class="form-actions">
            <button type="submit" class="btn btn-primary" :disabled="!selectedUser || isSaving">
              <span v-if="isSaving">{{ $t('asignando') }}…</span>
              <span v-else>{{ $t('asignar') }}</span>
            </button>
            <button type="button" class="btn btn-cancel" @click="$emit('close')">{{ $t('cancelar') }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api';

export default {
  props: {
    ticketId: { type: Number, required: true },
    users: { type: Array, default: () => [] },
    currentUserRole: null,
    currentUserId: null
  },
  data() {
    return {
      localUsers: [],
      selectedUser: null,
      filteredUsers: [],
      filterResponsibles: true,
      isSaving: false,
    };
  },
  computed: {
    isSupervisor() {
      return Number(this.currentUserRole) === 2;
    }
  },
  async created() {
    try {
      const rawUsers = (this.users && this.users.length)
        ? this.users
        : (await api.get('/users')).data.data ?? [];
       this.localUsers = rawUsers.map(u => {
        // Si el rol es objeto, extrae el id
        let rol_id = 0;
        if (typeof u.rol_id !== 'undefined') {
          rol_id = Number(u.rol_id);
        } else if (u.rol && typeof u.rol === 'object' && typeof u.rol.id !== 'undefined') {
          rol_id = Number(u.rol.id);
        } else if (typeof u.rol === 'number') {
          rol_id = u.rol;
        } else if (typeof u.role_id !== 'undefined') {
          rol_id = Number(u.role_id);
        }

        const responsable_id = u.responsable_id ?? u.responsable ?? u.responsable?.id ?? u.supervisor_id ?? null;
        const nombre_completo = u.nombre_completo || `${u.nombre || ''} ${u.apellidos || ''}`.trim() || u.nombre || 'Sin nombre';
        return { ...u, id: Number(u.id), nombre_completo, responsable_id, rol_id };
      });

      // Aplicar filtro inicial
      this.applyFilters();
    } catch (err) {
      if (import.meta.env.DEV) console.error('Error en AssignUserModal created:', err.response?.data || err.message);
      // opcional: notificar al usuario
      // import Swal si quieres mostrar alerta aquí
    }
   },
  watch: {
    filteredUsers(newList) {
      // Seleccionar el primero si no hay selección válida
      if (!this.selectedUser && newList && newList.length) {
        this.selectedUser = newList[0].id;
      }
      // Si la selección actual no está en la lista, resetearla
      if (this.selectedUser && !newList.find(u => u.id === this.selectedUser)) {
        this.selectedUser = newList.length ? newList[0].id : null;
      }
    }
  },
  methods: {
    applyFilters() {
      let list = [...this.localUsers];

      // Log para ver el valor de isSupervisor antes del if
      console.log('Valor de isSupervisor:', this.isSupervisor);
      console.log('Current User ID:', this.currentUserId);

      // Si el usuario actual es supervisor (rol 2), filtrar solo los que tienen como responsable al supervisor actual
      if (this.isSupervisor) {
        list = list.filter(u => (u.rol_id !== 4 && u.responsable_id === this.currentUserId) || u.id === this.currentUserId);
      } else {
        // Filtrar solo técnicos (rol distinto de 4)
        list = list.filter(u => u.rol_id !== 4 );
      }

      list.sort((a, b) => (a.nombre_completo || '').localeCompare(b.nombre_completo || ''));
      this.filteredUsers = list;

      // Depuración
      if (import.meta.env.DEV) {
        console.table(this.filteredUsers.map(u => ({
          id: u.id,
          nombre: u.nombre_completo,
          rol_id: u.rol_id,
          responsable_id: u.responsable_id
        })));
      }
    },

    async handleSubmit() {
      if (this.isSaving) return;
      this.isSaving = true;
      try {
        const payload = { usuario_id: this.selectedUser };
        const response = await api.put(`/tickets/${this.ticketId}/assign-user`, payload);

        const tecnico = this.filteredUsers.find(u => u.id === this.selectedUser)?.nombre_completo || '';
        this.$emit('user-assigned', { ...response.data, tecnico_nombre: tecnico, id: this.ticketId });
        this.$emit('close');
      } catch (error) {
        if (import.meta.env.DEV) console.error('Error al asignar el usuario:', error.response?.data || error.message);
        const msg = error.response?.data?.message || error.message || 'Error al asignar usuario';
        // Si quieres usar SweetAlert2, asegúrate de importarlo arriba:
        // import Swal from 'sweetalert2';
        Swal.fire({ icon: 'error', title: 'Error', text: msg, showConfirmButton: false, timer: 3000 });
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Fondo oscuro translúcido */
  z-index: 1000;
}

.modal-content {
  background-color: white; /* Fondo blanco */
  border-radius: 8px; /* Bordes redondeados */
  width: 500px; /* Ancho fijo */
  max-width: 90%; /* Ancho máximo relativo */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Sombra */
  overflow: hidden; /* Ocultar contenido desbordado */
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #99172A; /* Fondo rojo oscuro */
  color: white; /* Texto blanco */
  padding: 15px 20px; /* Espaciado interno */
  left: 0px;
  top: 0px;
}

.modal-title {
  margin: 0; /* Sin margen */
  font-size: 1.5rem; /* Tamaño de fuente */
}

.btn-close {
  filter: invert(1);
  opacity: 0.8;
}

.btn-close:hover {
  opacity: 1;
}

.btn-cancel {
  background-color: #6c757d;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 10px 20px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  margin-left: 10px;
  transition: background-color 0.3s ease;
  height: 40px;
  line-height: 20px;
  display: inline-block;
  vertical-align: middle;
}
.btn-cancel:hover {
  background-color: #495057;
}

.modal-body {
  padding: 20px; /* Espaciado interno */
}

.form-group {
  margin-bottom: 20px; /* Separación entre grupos */
}

.form-label {
  display: block; /* Mostrar como bloque */
  margin-bottom: 5px; /* Separación inferior */
  font-weight: bold; /* Texto en negrita */
}

.form-control {
  width: 100%; /* Ancho completo */
  padding: 10px; /* Espaciado interno */
  border: 1px solid #ced4da; /* Borde gris claro */
  border-radius: 4px; /* Bordes redondeados */
  font-size: 1rem; /* Tamaño de fuente */
}

.form-actions {
  text-align: right; /* Alinear a la derecha */
}

.btn-primary {
  background-color: #99172A; /* Fondo rojo oscuro */
  color: white; /* Texto blanco */
  border: none; /* Sin borde */
  padding: 10px 20px; /* Espaciado interno */
  border-radius: 4px; /* Bordes redondeados */
  cursor: pointer; /* Cambiar cursor al pasar */
  font-size: 1rem;
  font-weight: bold;
  height: 40px;
  line-height: 20px;
  display: inline-block;
  vertical-align: middle;
}

.btn-primary:hover {
  background-color: #7A1222; /* Fondo más oscuro al pasar */
}

.modal-overlay {
  position: fixed; /* Posición fija */
  top: 0;
  left: 0;
  width: 100%; /* Ancho completo */
  height: 100%; /* Altura completa */
  background-color: rgba(0, 0, 0, 0.5); /* Fondo oscuro translúcido */
  display: flex; /* Usar flexbox */
  justify-content: center; /* Centrar horizontalmente */
  align-items: center; /* Centrar verticalmente */
  z-index: 1000; /* Prioridad alta */
}
</style>